import { getNodeHandleId } from 'Automations/nodeDefinitions/helpers/nodeHandleId'

/**
 * The source handle id of a node's primary (first) output.
 *
 * Linear nodes (no `handleMapping`) have a single, unnamed source handle.
 * Branching nodes expose a `handleMapping` of `key → index`; the primary
 * output is the lowest-indexed handle (Switch → first group, Review →
 * APPROVED). Used when splicing a node onto an edge so the downstream
 * connection is wired to the node's main path.
 */
export const getPrimaryOutputHandleId = ({
  nodeId,
  handleMapping
}: {
  nodeId: string
  handleMapping?: Record<string, number>
}): string => {
  if (!handleMapping) {
    return getNodeHandleId({ nodeId, type: 'source' })
  }

  const primaryKey = Object.entries(handleMapping)
    .sort(([, a], [, b]) => a - b)
    .map(([key]) => key)
    .at(0)

  if (!primaryKey) {
    return getNodeHandleId({ nodeId, type: 'source' })
  }

  return getNodeHandleId({ nodeId, type: 'source', handleMapping: primaryKey })
}
